export default __webpack_public_path__ + "dd3cabaec283ee286d91f19ed35d1db1.png";